module.exports = "/_next/static/images/8ba762ddc6677f740ecec7af37a811bc-blog1-xs.png.webp";